<template>
  <div class="api-doc-container">
    <div class="doc-content">
      <h1>HERON6000 文档中心</h1>
      <div class="doc-links">
        1、使用手册<br />
        <router-link to="/doc/instruction">中文</router-link> | <router-link to="/doc/instruction_en">English</router-link>
        </div>
      <div class="doc-links">
        <router-link to="/doc/interface">2、接口文档</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocIndex',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  mounted() { },
  created() { },
  methods: {}
}
</script>

<style scoped>
.api-doc-container {
  min-height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  background: #f8fafc; /* subtle background */
}

.doc-content {
  width: 100%;
  max-width: 720px;
  text-align: left; /* ensure lines are left-aligned */
}

h1 {
  margin: 0 0 16px;
  font-size: 28px;
  line-height: 1.3;
  color: #0f172a; /* slate-900 */
  font-weight: 700;
}
.doc-links {
  margin: 12px 0;
  padding: 12px 16px;
 
  background-color: #ffffff;
  border-radius: 4px;
  transition: all 0.3s ease;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.doc-links:hover {
  background-color: #eef5ff;
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* 第一个div的特殊处理（有数字1） */
.doc-links:first-child {
  counter-reset: doc-counter;
}

.doc-links:first-child::before {
  content: "1";
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: #3498db;
  color: white;
  border-radius: 50%;
  margin-right: 12px;
  font-weight: 600;
  font-size: 14px;
}



/* 链接样式 */
.doc-links a {
  color: #2c3e50;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
  display: inline-block;
  padding: 4px 0;
  position: relative;
}

.doc-links a:hover {
  color: #3498db;
}

/* 链接激活状态 */
.doc-links a.router-link-active {
  color: #3498db;
  font-weight: 600;
}

/* 链接下划线效果 */
.doc-links a::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #3498db;
  transition: width 0.3s ease;
}

.doc-links a:hover::after {
  width: 100%;
}

/* 中英文链接之间的分隔符 */
.doc-links:first-child a + a {
  margin-left: 4px;
}

/* 添加分隔符 */
.doc-links:first-child a:first-child::after {
  content: " | ";
  color: #95a5a6;
  margin: 0 4px;
  font-weight: 300;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .doc-links {
    padding: 10px 12px;
    font-size: 14px;
  }
  
  .doc-links::before {
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    margin-right: 8px;
  }
}
</style>
